import {NextPage} from 'next';
import {NoSsr, HeadTitle} from '@/components/common-components';
import {serverSideTranslations} from 'next-i18next/serverSideTranslations';
import {PageEditor} from '@/components/dashboard/pages/landing-page-optimizer/page-editor';
import {RootStoreType} from '@/store/root-store';
import {ErrorBoundary} from '../../../components/ErrorBoundary';
import {observer} from 'mobx-react';

const SinglePage: NextPage<{rootStore: RootStoreType}> = observer(({rootStore}) => {
  return (
    <>
      <HeadTitle>{rootStore?.contentOptimizer?.currentPage?.content?.title}</HeadTitle>
      <NoSsr>
        <ErrorBoundary>
          <PageEditor rootStore={rootStore} isPublic={false}/>
        </ErrorBoundary>
      </NoSsr>
    </>
  );
});

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: true,
  };
}

export const getStaticProps = async ({locale}) => ({
  props: {
    ...await serverSideTranslations(locale, ['common', 'components', 'landing-page-optimizer', 'settings', 'keyword-researcher']),
  },
});

export default SinglePage;
